import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import {
    HitData, ResultData, ResultType, BattedBallType, HitReprocessed, ResultDataNew, DataSection, TaggingData, PitchReprocessed
} from "../../enums/index.js";
import defaultBattedBallTypeClassifier from '../../classificators/battedBallTypeClassifier.js';
import ResultPair from "../../valueObjects/ResultPair.js";
import IterableDataProcessor from "../../entities/IterableDataProcessor.js";

// see https://docs.google.com/document/d/1Vy6RyhEqXyqW0_5aKtMIs9jwaPFw6jztjZNUkVY_VRc/edit#heading=h.lv1tt1srxz43
// https://library.fangraphs.com/pitching/batted-ball/
class BattedBallTypeFormatter extends ResultsFormatterBase {
    constructor(battedBallTypeClassifier, newStructure) {
        super();

        if (typeof(battedBallTypeClassifier) === 'undefined') {
            this.battedBallTypeClassifier = defaultBattedBallTypeClassifier;
        }
        else if (typeof(battedBallTypeClassifier) !== 'function') {
            throw new TypeError('battedBallTypeClassifier must be an function or undefined');
        }
        else {
            this.battedBallTypeClassifier = battedBallTypeClassifier;
        }

        if (typeof(newStructure) === 'undefined') {
            this.newStructure = false;
        }
        else if(typeof(newStructure) === 'boolean') {
            this.newStructure = newStructure;
        }
        else {
            throw new TypeError('newStructure must be boolean or undefined');
        }
    }

    format(results) {
        const dataKey = this.newStructure ? ResultDataNew.Data.key : ResultData.Data.key;
        const typeKey = this.newStructure ? ResultDataNew.Type.key : ResultData.Type.key;

        for (let i = 0; i < results.length; i++) {
            let result = results[i];

            if (!result || !result[dataKey]) {
                continue;
            }

            if (this.newStructure) {
                // prefer tagging data
                let taggedBBT = BattedBallType.Unidentified.key;
                if (result[dataKey][DataSection.Tagging.key]) {
                    if (result[dataKey][DataSection.Tagging.key][ResultPair.getPitchProperty()]) {
                        taggedBBT = result[dataKey][DataSection.Tagging.key][ResultPair.getPitchProperty()][TaggingData.BattedBallType.key];
                    }
                    else if (result[dataKey][DataSection.Tagging.key][ResultPair.getHitProperty()]) {
                        taggedBBT = result[dataKey][DataSection.Tagging.key][ResultPair.getHitProperty()][TaggingData.BattedBallType.key];
                    }

                    if (!taggedBBT || taggedBBT === BattedBallType.Unidentified.key) {
                        const verticalLaunch = IterableDataProcessor.getObjectContent(
                            result, ResultDataNew.getDataPath(HitData.LaunchV.key, DataSection.Sensor.key, ResultType.Hit.key)
                        );

                        taggedBBT = this.determineBallType(verticalLaunch);
                    }
                }
                else {
                    result[dataKey][DataSection.Tagging.key] = {};
                }
                if (ResultType.hasHit(result[typeKey])) {
                    IterableDataProcessor.setObjectContent(
                        result,
                        ResultDataNew.getDataPath(HitReprocessed.BattedBallTypeR.key, DataSection.Tagging.key, ResultType.Hit.key),
                        taggedBBT
                    );
                }

                if (ResultType.hasPitch(result[typeKey])) {
                    IterableDataProcessor.setObjectContent(
                        result,
                        ResultDataNew.getDataPath(PitchReprocessed.BattedBallTypeR.key, DataSection.Tagging.key, ResultType.Pitch.key),
                        taggedBBT
                    );
                }
            }
            else {
                if (!ResultType.hasHit(result[typeKey])) {
                    continue;
                }

                if (!result.hasOwnProperty(dataKey) || !result[dataKey]) {
                    continue;
                }

                if (result[dataKey][TaggingData.BattedBallType.key] && result[dataKey][TaggingData.BattedBallType.key] !== BattedBallType.Unidentified.key) {
                    result[dataKey][HitReprocessed.BattedBallTypeR.key] = result[dataKey][TaggingData.BattedBallType.key];
                    continue;
                }

                result[dataKey][HitReprocessed.BattedBallTypeR.key] = BattedBallType.Unidentified.key;

                const verticalLaunch = result[dataKey][HitData.LaunchV.key];
                result[dataKey][HitReprocessed.BattedBallTypeR.key] = this.determineBallType(verticalLaunch);
            }
        }

        return results;
    }

    determineBallType(verticalLaunchAngle){
        return this.battedBallTypeClassifier(verticalLaunchAngle);
    }
};

export default BattedBallTypeFormatter;